import { ErrorMessageOrderDetailNotFound } from './OrderHistoryDetailNotFound'

export const HTTP_ERROR_MESSAGE_COMPONENTS = {
  orderHistoryNotFound: ErrorMessageOrderDetailNotFound,
}
